import { useNavigate } from 'react-router-dom';

import { useAuth0 } from '@auth0/auth0-react';
import { Link } from '@mui/material';

import AccessDenied from '@/components/shared/AccessDenied';
import { email } from '@/config';

const Auth0Failure = () => {
  const navigate = useNavigate();
  const { logout } = useAuth0();

  return (
    <AccessDenied
      title="Access Denied"
      description={
        <>
          We could not verify your account access. If you believe this is an
          error, reach out to your organization’s administrator or contact{' '}
          <Link href={`mailto:${email}`} sx={{ color: 'primary.main' }}>
            {email}
          </Link>{' '}
          for help.
        </>
      }
      actionButtons={{
        primary: {
          label: 'Go Back',
          onClick: () => navigate(-1),
        },
        secondary: {
          label: 'Log Out',
          onClick: () => logout(),
        },
      }}
    />
  );
};
export default Auth0Failure;
